__turbopack_context__.v({
  "col": "_5S8nYq_col",
  "descriptionText": "_5S8nYq_descriptionText",
  "logo__lVytp": "_5S8nYq_logo__lVytp",
  "subtitleText": "_5S8nYq_subtitleText",
});
